import clsx from 'clsx';
import styles from './BulletList.module.scss';

type BulletListAllowedChildren = React.ReactElement<React.ComponentProps<typeof BulletListItem>>;

interface BulletListProps {
  children:
    | BulletListAllowedChildren
    | BulletListAllowedChildren[]
    | (BulletListAllowedChildren | BulletListAllowedChildren[])[];
  className?: string;
  testId?: string;
  columnLayout?: boolean;
}

export const BulletList: React.FC<BulletListProps> = ({
  children,
  className,
  testId,
  columnLayout,
}) => (
  <ul
    className={clsx(styles.list, className, {
      [styles.listColumns]: columnLayout,
    })}
    data-testid={testId}
  >
    {children}
  </ul>
);

interface BulletListItemProps {
  children: React.ReactNode;
  className?: string;
  testId?: string;
  hidden?: boolean;
}

export const BulletListItem: React.FC<BulletListItemProps> = ({
  children,
  className,
  testId,
  hidden,
}) => (
  <li className={clsx(styles.item, className)} data-testid={testId} hidden={hidden}>
    {children}
  </li>
);
